import React, { FC } from 'react';

import Modal from '~components/atoms/Modal';

import { useAppSelector } from '~redux/hooks';
import Table from '~components/molecules/Table';
import * as CustomerHoldingsStyles from './CustomerHoldingsListing.modules.scss';

type CustomerHoldingsListingModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const CustomerHoldingsListingModal: FC<CustomerHoldingsListingModalProps> = ({
    isOpen,
    onClose,
}) => {
    const selectedCustomerHoldings = useAppSelector(state => state.customer.customerHoldingsListing);
    const isLoadingCustomerHoldingsListing = useAppSelector((state) => state.customer.loadings.getCustomerHoldings);

    const tableHeader = [
        'Serial Number',
        'Total Weight (G)',
    ];

    const tableBody = (selectedCustomerHoldings?.paperGold ?? selectedCustomerHoldings?.paperSilver ?? []).map(
        item => {
            const { serialNo, totalWeight } = item;
            return [serialNo, totalWeight,];
        }
    );
    
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title='Customer Holdings List'
        >
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoadingCustomerHoldingsListing}
                containerClassName={CustomerHoldingsStyles['table-container']}
            />
        </Modal>
    );
};

export default CustomerHoldingsListingModal;
